import api from '@/api/api';

const DOMAIN = '/admin';

const getMeAdmin = async (): Promise<Admins.Admin> => {
	const { data } = await api.get(`${DOMAIN}/me`);
	return data;
};

const login = async ({
	email,
	password,
}: {
	email: string;
	password: string;
}): Promise<Admins.LoginResponse> => {
	const { data } = await api.post(`${DOMAIN}/login`, { email, password });
	return data;
};

const logout = async (): Promise<void> => {
	api.delete(`${DOMAIN}/logout`);
};

const getAll = async (): Promise<Admins.Admin[]> => {
	const { data } = await api.get(`${DOMAIN}`);
	return data;
};

const AdminService = {
	getMeAdmin,
	getAll,
	login,
	logout,
};

export { AdminService };
